module.exports = __webpack_public_path__ + "img/3_162.13c98cc2.png";